import React from "react"
import PropTypes from "prop-types"
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment'

class DateInput extends React.Component {

  constructor(props) {
    super(props)

    this.updateDate = this.updateDate.bind(this)
  }

  updateDate(value) {
    this.props.onChange(value)
  }

  render() {
      return(
        <div
          style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
            <p className="label_standard">{this.props.label}</p>
            {this.props.inputError.length > 0 && <p className="input_error">{this.props.inputError}</p>}
            <DatePicker
              className="input_standard"
              selected={this.props.value}
              onChange={(value) => this.updateDate(value)}
              dateFormat="MMMM d, yyyy"
              minDate={this.props.minDate}
              maxDate={this.props.maxDate}
              showYearDropdown={this.props.showYearDropdown ? this.props.showYearDropdown : false}
              showMonthDropdown={this.props.showMonthDropdown ? this.props.showMonthDropdown : false}
            />
        </div>
      )
  }
}

export default DateInput;
